import { useAnalyticsFilters } from "providers/AnalyticsProvider/AnalyticsFilterProvider";
import { PRODUCT_DISPLAY_NAMES } from "utils/analytics/constants";
import FilterPill from "./shared/components/FilterPill";

export function ActiveFilterPills() {
  const { filters, setFilters } = useAnalyticsFilters();

  const removeItem = (type: keyof typeof filters, value: string) => {
    setFilters({
      ...filters,
      [type]: Array.isArray(filters[type])
        ? (filters[type] as string[]).filter((v) => v !== value)
        : [],
    });
  };

  return (
    <div className="flex gap-2 flex-wrap my-2">
      {filters.domains.map((domain) => (
        <FilterPill key={domain} label={domain} onRemove={() => removeItem("domains", domain)} />
      ))}
      {filters.countries.map((country) => (
        <FilterPill key={country} label={country} onRemove={() => removeItem("countries", country)} />
      ))}
      {filters.parameters.map((param) => (
        <FilterPill key={param} label={param} onRemove={() => removeItem("parameters", param)} />
      ))}
      {filters.productType && (
        <FilterPill
          label={PRODUCT_DISPLAY_NAMES[filters.productType] || filters.productType}
          onRemove={() => setFilters({ ...filters, productType: null })}
        />
      )}
    </div>
  );
}

export function ErrorLogFilterPills() {
  const { errorLogsFilters, setErrorLogsFilters } = useAnalyticsFilters();

  const removeItem = (type: keyof typeof errorLogsFilters, value: string) => {
    setErrorLogsFilters({
      [type]: Array.isArray(errorLogsFilters[type])
        ? (errorLogsFilters[type] as string[]).filter((v) => v !== value)
        : [],
    });
  };

  return (
    <div className="flex gap-2 flex-wrap my-2">
      {errorLogsFilters.domains.map((domain) => (
        <FilterPill key={domain} label={domain} onRemove={() => removeItem("domains", domain)} />
      ))}
      {errorLogsFilters.statusCodes.map((code) => (
        <FilterPill key={code} label={code} onRemove={() => removeItem("statusCodes", code)} />
      ))}
      {errorLogsFilters.severity && (
        <FilterPill
          label={errorLogsFilters.severity.charAt(0).toUpperCase() + errorLogsFilters.severity.slice(1)}
          onRemove={() => setErrorLogsFilters({ severity: null })}
        />
      )}
    </div>
  );
}
